/** Loading placeholder matching the EventCard footprint. */
import { Skeleton } from '@/components/ui';

export function EventCardSkeleton() {
  return (
    <li className="overflow-hidden rounded-xl border border-border bg-surface shadow-sm">
      <Skeleton className="aspect-square w-full rounded-none" />
      <div className="p-4">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="mt-1.5 h-4 w-3/4" />
        <Skeleton className="mt-3 h-3 w-5/6" />
        <Skeleton className="mt-1.5 h-3 w-2/3" />
      </div>
    </li>
  );
}
